<template>
	<div class="content-wrapper">
		<div class="sf-flex-column" v-if="isLoaded">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pmcTrackingSearchContainer ref="pmcTrackingSearch" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-6">
				<pmcTrackingTableMasterInfo ref="tablemasterinfo" @Refresh="Refresh" :scrId="scrId" />
			</div>
			<div class="sf-col sf-col-14">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pmcTrackingTableContainer ref="tableContainer" @Refresh="Refresh" @PopupRoOpen="PopupRoOpen" :scrId="scrId" />
					<ro-apcn-popup ref="roApcnPopup" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import PmcTrackingSearchContainer from './Search/PmcTrackingSearchContainer.vue';
import PmcTrackingTableContainer from './Table/PmcTrackingTableContainer.vue';
import PmcTrackingTableMasterInfo from './Table/PmcTrackingTableMasterInfo.vue';
import RoApcnPopup from '@mqy/ceqi/RoApcn/Content/RoApcnPopup/RoApcnPopup.vue'; //RO 신청 현황 팝업부분

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			favorite: true,
			screen: {},
			isLoaded: false
		};
	},
	components: {
		PmcTrackingSearchContainer,
		PmcTrackingTableContainer,
		PmcTrackingTableMasterInfo,
		RoApcnPopup
	},
	async created() {
		//const value = (await this.inclManyUsrGrp_(['MQYPC', 'OS'])) ? 'MQYPC' : '';
		//this.setState_({ key: 'authCode', value });
		this.isLoaded = true;
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		Refresh() {
			this.$sf_toggleLoading(false);
			//this.$refs.pmcTrackingSearch.searchList();
		},
		sendData(param) {
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cpnyCd 는 ' + param.cpnyCd + ', cpnyNm은 ' + param.cpnyNm);
			this.sendParam = param;
		},
		PopupRoOpen(param) {
			//alert('여기호출');

			this.$refs.roApcnPopup.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		}
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	}
};
</script>

<style></style>
